enum PvPRank {
  Scout = 1,
  Private = 1,
  Grunt = 2,
  Corporal = 2,
  Sergeant = 3,
  SeniorSergeant = 4,
  MasterSergeant = 4,
  FirstSergeant = 5,
  SergeantMajor = 5,
  StoneGuard = 6,
  Knight = 6,
  BloodGuard = 7,
  KnightLieutenant = 7,
  Legionnaire = 8,
  KnightCaptain = 8,
  Centurion = 9,
  KnightChampion = 9,
  Champion = 10,
  LieutenantCommander = 10,
  LieutenantGeneral = 11,
  Commander = 11,
  General = 12,
  Marshal = 12,
  Warlord = 13,
  FieldMarshal = 13,
  HighWarlord = 14,
  GrandMarshal = 14
}

export default PvPRank
